import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class HttpErrorInterceptor implements HttpInterceptor {

  constructor(private _dialog: MatDialog) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(request)
      .pipe(
        retry(1),
        catchError((error: HttpErrorResponse) => {
          let errorMessage = '';
          let showRefreshButton = false;

          if (error.status === 401) {
            errorMessage = `U heeft niet voldoende rechten. Ververs de pagina om opnieuw in te loggen`;
            showRefreshButton = true;
          }
          else if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `Error: ${error.error.message}`;
          } else {
            // server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
          }

          const confirmDialog = this._dialog.open(ConfirmDialogComponent, {
            data: {
              title: 'Fout',
              message: errorMessage,
              hideConfirm: true,
              showRefreshButton: showRefreshButton
            }
          });

          //window.alert(errorMessage);

          return throwError(errorMessage);
        })
      )
  }
}
